import React from 'react';
import { useSelector } from 'react-redux';
import { renderRoutes } from 'react-router-config';
import cx from 'classnames';

import Header from '../components/Header';
import Footer from '../components/Footer';
import FooterMobile from '../components/FooterMobile';
import GNB from '../components/GNB';
import useCanRenderSmartBannerPage from '../hooks/useCanRenderSmartBanner';
import { isMobileSelector } from '../selector/device';

function LayoutDefault(props) {
  const isMobile = useSelector(isMobileSelector);
  const canRenderSmartBanner = useCanRenderSmartBannerPage();

  return (
    <div className="min-h-screen flex flex-col">
      <GNB className="z-20 relative" />
      <Header className={cx(
        'flex-none relative', 
        isMobile && canRenderSmartBanner && props.isSmartBannerShowed ? '' : 'z-20 sticky top-0'
      )}/>

      <div
        className="flex-auto min-h-screen-with-navbar relative z-10 flex flex-col"
        style={{'--navbar-height': isMobile && canRenderSmartBanner && props.isSmartBannerShowed ? 'var(--smartbanner-height)' : undefined}}
      >
        {renderRoutes(props.route.routes, { ssrData: props.ssrData })}
      </div>

      {isMobile ? <FooterMobile className="flex-none" /> : <Footer className="flex-none" />}
    </div>
  );
}

export default LayoutDefault;
